import Color from "color"
import Axios from 'axios'

const store = { namespaced: true, getters: {}, mutations: {}, actions: {}, state: {}};

const frontendResource = 'frontend/api/v1';

store.state.theme = {
    '--background-color': Color("#262C32"),
    '--accent-color': Color("#C84A4B"),
}

store.state.theme['--accent-color-minus-25'] = store.state.theme["--accent-color"].darken(0.25);
store.state.theme['--accent-color-minus-50'] = store.state.theme["--accent-color"].darken(0.50);
store.state.theme['--accent-color-minus-75'] = store.state.theme["--accent-color"].darken(0.75);

store.state.theme['--accent-color-plus-10'] = store.state.theme["--accent-color"].lighten(0.1);
store.state.theme['--accent-color-plus-25'] = store.state.theme["--accent-color"].lighten(0.25);
store.state.theme['--accent-color-plus-50'] = store.state.theme["--accent-color"].lighten(0.50);
store.state.theme['--accent-color-plus-75'] = store.state.theme["--accent-color"].lighten(0.75);

store.state.theme['--selection-color'] = store.state.theme["--accent-color"].lighten(0.25);
store.state.theme['--header-font-color'] = store.state.theme["--background-color"].whiten(20);

store.state.theme['--card-background-color'] = store.state.theme["--background-color"].lighten(0.5);
store.state.theme['--card-light-background-color'] = store.state.theme["--background-color"].lighten(0.7);
store.state.theme['--card-font-color'] = store.state.theme["--card-background-color"].lighten(2);

store.state.theme['--table-body-color'] = store.state.theme["--card-background-color"]//.lighten(1);
store.state.theme['--table-body-font-color'] = store.state.theme["--card-background-color"].lighten(1.75)//.lighten(1);
store.state.theme['--table-body-selection-color'] = store.state.theme["--accent-color"].mix(store.state.theme["--card-background-color"]).lighten(0.1)//.lighten(1);
store.state.theme['--table-body-font-selection-color'] = store.state.theme["--accent-color"].lighten(2.5)//.lighten(1);
store.state.theme['--table-body-highlight-color'] = store.state.theme["--accent-color"].darken(0.2).mix(store.state.theme["--card-background-color"])
store.state.theme['--table-body-font-highlight-color'] = store.state.theme["--accent-color"].lighten(0.2)
store.state.theme['--table-header-color'] = store.state.theme["--card-background-color"]//.lighten(1);
store.state.theme['--table-header-font-color'] = store.state.theme["--card-background-color"].lighten(2)//.lighten(1);
store.state.theme['--table-border-color'] = store.state.theme["--card-background-color"].lighten(0.55)//.lighten(1);


store.state.theme['--input-border-color'] = store.state.theme["--card-background-color"].lighten(0.4)
store.state.theme['--input-background-color'] = store.state.theme["--card-background-color"].lighten(0.05)
store.state.theme['--input-font-color'] = store.state.theme["--card-background-color"].lighten(1.7)
store.state.theme['--input-selection-color'] = store.state.theme["--accent-color"].lighten(0.2)
store.state.theme['--input-active-font-color'] = store.state.theme["--input-font-color"].lighten(0.3)
store.state.theme['--input-active-background-color'] = store.state.theme["--input-background-color"]
store.state.theme['--input-active-border-color'] = store.state.theme["--input-border-color"].lighten(0.4)
store.state.theme['--input-placeholder-font-color'] = store.state.theme["--card-background-color"].lighten(0.3)

store.state.theme['--input-list-background-color'] = store.state.theme["--input-background-color"].lighten(0.3)
store.state.theme['--input-list-selection-color'] = store.state.theme["--accent-color"].lighten(0.04);

store.state.theme['--input-check-off-background-color'] = store.state.theme["--input-background-color"].lighten(0.3)
store.state.theme['--input-check-on-background-color'] = store.state.theme["--input-background-color"].lighten(0.3)
store.state.theme['--input-check-off-color'] = store.state.theme["--accent-color"]
store.state.theme['--input-check-on-color'] = Color("rgb(135,161,95)")
store.state.theme['--input-check-on-color-plus-10'] = Color("rgb(135,161,95)").lighten(0.1)

store.state.theme['--button-font-color'] = store.state.theme["--input-font-color"].lighten(0.3)
store.state.theme['--button-background-color'] = store.state.theme["--accent-color"]
store.state.theme['--button-background-hover-color'] = store.state.theme['--button-background-color'].darken(0.2)

store.state.theme['--divider-color'] = store.state.theme["--card-background-color"].lighten(0.5);


store.state.helpItems = {

}

store.state.languages = [];

store.mutations['SET_LANGUAGES'] = (state, languages) => {
    state.languages = languages;
}

store.actions.loadLanguages = ({commit}) => {
    return Axios.get(`${frontendResource}/available-languages`)
        .then(res => commit('SET_LANGUAGES', res.data));
}

store.actions.loadHelpItem = ({commit}, code) => {
    return Axios.get(`${frontendResource}/help/items?code=${code}`)
        .then(res => res.data);
}

store.actions.saveHelpItem = ({commit}, helpItem) => {
    return Axios.post(`${frontendResource}/help/items`, helpItem, { headers: { "Content-Type": "application/json"}})
}

export default store;